import { connect, MapStateToProps } from "react-redux";

import { createGetAttributeNameIndex, createGetBackgroundAttributeColor, getBackgroundAttributeName } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { getInteractive } from "../../../selectors";
import { FrameAttributeSharedProps } from "../../../types";
import { PlaceholderComponent, PlaceholderProps } from "../types";

type StateProps = Pick<
    PlaceholderProps,
    "attributeIndex" | "interactive" | "backgroundAttributeName"
>;

const createMapStateToProps: () => MapStateToProps<StateProps, FrameAttributeSharedProps, IAppState> = () => {
    const getAttributeIndex = createGetAttributeNameIndex();
    const getBackgroundAttributeColor = createGetBackgroundAttributeColor();

    return (state, { dataSourceKey, recordId, attributeName }) => ({
        attributeIndex: getAttributeIndex(state, { dataSourceKey, attributeName }),
        interactive: getInteractive(state, dataSourceKey),
        backgroundAttributeColor: getBackgroundAttributeColor(state, { dataSourceKey, recordId, attributeName }),
        backgroundAttributeName: getBackgroundAttributeName(state, { dataSourceKey, attributeName }),
    });
};

export const connectPlaceholder = (PlaceholderComponent: PlaceholderComponent) => connect(createMapStateToProps)(PlaceholderComponent);
